import React, { Component, Suspense } from 'reactn';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormService } from './form.service';
import { showHideLoader } from '../../../v2/core/store/.';
import { Loader } from '@orijinworks/frontend-commons';


const FormList = React.lazy(() => import('./forms-list'));
const FormSubmissions = React.lazy(() => import('./forms-submission'));

class Forms extends Component {

    state = {
        isManageFormOpen: false,
        selectedForm: null,
    };
    formService = new FormService();

    /**
     * @name initPropToState
     * @desc A wrapper method to initialize properties from prop to state.
     * @return {void}
     */
    initPropToState = () => {
        this.setState({
            location: this.props.location,
            selectedForm: null,
        });
    };

    componentDidMount() {
        this.initPropToState();
    };

    componentDidUpdate() {
        if (this.props.location.active !== this.state.location?.active) {
            this.initPropToState();
            this.forceUpdate();
        }
    };

    /**
     * @name manageLoader
     * @param {boolean} isLoading
     * @desc Manages loading state.
     * @return {void}
     */
    manageLoader = (isLoading) => {
        this.setGlobal({
            isLoading
        });
    };

    onFormSelect = (rowData) => {
        this.setState({
            selectedForm: {
                id: rowData.id,
                formId: rowData.formId,
                formName: rowData.name,
                locationId: this.props.location.active,
            }
        });
    };

    onFormBack = () => {
        this.setState({ selectedForm: null });
    };

    render() {
        if (this.state.selectedForm) {
            return (
                <Suspense fallback={<Loader isLoading={true} />}>
                    <FormSubmissions
                        {...this.props}
                        formId={this.state.selectedForm.formId}
                        locationId={this.state.selectedForm.locationId}
                        formName={this.state.selectedForm.formName}
                        id={this.state.selectedForm.id}
                        locationName={this.props.location.locationName}
                        onBack={this.onFormBack}
                    />
                </Suspense>
            );
        }

        return (
            <Suspense fallback={<Loader isLoading={true} />}>
                <FormList
                    global={this.global}
                    cbacConfigFlag={this.global.cbacConfigFlag}
                    permissions={this.global.permissions}
                    toggleLoader={this.manageLoader}
                    onFormSelect={this.onFormSelect}
                    props={{ ...this.props }}
                />
            </Suspense>
        );
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        toggleLoader: (isLoading) => dispatch(showHideLoader({ isLoading: isLoading }))
    };
};

Forms.propTypes = {
    location: PropTypes.shape({
        active: PropTypes.string,
        locationName: PropTypes.string,
        collection: PropTypes.array,
    }).isRequired,
};

export default connect(null, mapDispatchToProps)(Forms);
